var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOptions}},[_vm._l((_vm.banners),function(item,index){return _c('swiper-slide',{key:index},[_c('img',{attrs:{"src":item.img},on:{"load":_vm.onLoad}})])}),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }